import Parse from "parse";

type OD3_Tenant = Parse.Object;

export interface AttachmentAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  file: Parse.File;
  description?: string;
  name: string;
  image: boolean;
  tenant: OD3_Tenant;
}

export class Attachment extends Parse.Object<AttachmentAttributes> {
  constructor(data?: Partial<AttachmentAttributes>) {
    super("APP_Attachment", data as AttachmentAttributes);
  }
}

Parse.Object.registerSubclass("APP_Attachment", Attachment);
